/**
 * This component reads the local logo file uploaded to the front-end and formats the data
 * as a data URL to avoid issues with CORS. It is intended to be used for the logo color picker
 * functionality and is related to <LogoColorSelector /> and <LogoDragAndDrop />
 */

import React, { useState } from 'react';

const LogoFilePreview = ({
  alt = 'Logo preview.',
  file,
  imgRef,
}: {
  file: File;
  alt?: string;
  imgRef: React.MutableRefObject<HTMLImageElement>;
}): JSX.Element => {
  const [src, setSrc] = useState<string>();
  const reader = new FileReader();
  const loadEndHandler = () => {
    // reader.result can be a string OR an ArrayBuffer; convert to string
    const result = reader.result.toString();
    setSrc(result);
  };
  reader.readAsDataURL(file);
  // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/loadend_event
  reader.addEventListener('loadend', loadEndHandler, false);
  return (
    src &&
      <img alt={alt} ref={imgRef} src={src} />
  );
};

export default LogoFilePreview;
